// project imports
import { getIriFromObj, processDateFieldInput, processDateFieldOutput } from 'utils/processors';

export const processEntityInput = (values) => ({
    createdAt: 'createdAt' in (values || {}) ? processDateFieldInput(values.createdAt) : null,
    updatedAt: 'updatedAt' in (values || {}) ? processDateFieldInput(values.updatedAt) : null
});

export const processEntityOutput = (values) => ({
    createdAt: 'createdAt' in (values || {}) ? processDateFieldOutput(values.createdAt, 'yyyy-MM-dd HH:mm') : undefined,
    createdBy: 'createdBy' in (values || {}) ? getIriFromObj(values?.createdBy) : undefined,
    updatedAt: 'updatedAt' in (values || {}) ? processDateFieldOutput(values.updatedAt, 'yyyy-MM-dd HH:mm') : undefined,
    updatedBy: 'updatedBy' in (values || {}) ? getIriFromObj(values?.updatedBy) : undefined
});
